import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import { ToastProvider } from './components/Submissions/Toast';

// Suppress network/extension CORS or block failures from showing Webpack DevServer error overlay
if (typeof window !== 'undefined') {
  // Global fetch interceptor to dynamically rewrite API domains
  // - In development: Uses relative pathing so Webpack DevServer proxies the request
  // - In production: Routes through proxy.php on the local server to bypass WAF CORS blocks
  const originalFetch = window.fetch;
  window.fetch = function (input, init) {
    let url = typeof input === 'string' ? input : (input && input.url);
    
    if (url) {
      const hasOldDomain = url.includes('emiratesscholar.com');
      const hasNewDomain = url.includes('emiratesscholar.ae');
      
      if (hasOldDomain || hasNewDomain) {
        // Clean URL to get the path relative to the domain (e.g. system/api/login)
        const path = url
          .replace('https://emiratesscholar.com/', '')
          .replace('https://www.emiratesscholar.com/', '')
          .replace('https://emiratesscholar.ae/', '')
          .replace('https://www.emiratesscholar.ae/', '');

        // Determine if running on local dev server
        const isLocal = 
          window.location.hostname === 'localhost' || 
          window.location.hostname === '127.0.0.1' || 
          window.location.hostname.endsWith('.local') || 
          window.location.port !== '' ||
          /^127\./.test(window.location.hostname) ||
          /^10\./.test(window.location.hostname) ||
          /^172\.(1[6-9]|2[0-9]|3[0-1])\./.test(window.location.hostname) ||
          /^192\.168\./.test(window.location.hostname);

        const targetUrl = isLocal 
          ? '/' + path 
          : '/proxy.php?url=' + encodeURIComponent(path);

        if (typeof input === 'string') {
          input = targetUrl;
        } else {
          const requestProps = {};
          const keys = ['method', 'headers', 'body', 'mode', 'credentials', 'cache', 'redirect', 'referrer', 'integrity', 'keepalive', 'signal'];
          keys.forEach(key => {
            if (input[key] !== undefined) {
              requestProps[key] = input[key];
            }
          });
          input = new Request(targetUrl, requestProps);
        }
      }
    }
    return originalFetch(input, init);
  };

  const ignoreErrors = ['Failed to fetch', 'Load failed', 'NetworkError', 'CORS'];
  
  window.addEventListener('unhandledrejection', (event) => {
    const msg = event.reason?.message || '';
    const stack = event.reason?.stack || '';
    if (ignoreErrors.some(err => msg.includes(err)) || stack.includes('chrome-extension') || msg.includes('chrome-extension')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  window.addEventListener('error', (event) => {
    const msg = event.message || '';
    const stack = event.error?.stack || '';
    if (ignoreErrors.some(err => msg.includes(err)) || stack.includes('chrome-extension') || msg.includes('chrome-extension')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
}

// إضافة خطوط Google
const link = document.createElement('link');
link.href = 'https://fonts.googleapis.com/icon?family=Material+Icons';
link.rel = 'stylesheet';
document.head.appendChild(link);

const link2 = document.createElement('link');
link2.href = 'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200';
link2.rel = 'stylesheet';
document.head.appendChild(link2);

const link3 = document.createElement('link');
link3.href = 'https://fonts.googleapis.com/css2?family=Tajawal:wght@200;300;400;500;700;800;900&display=swap';
link3.rel = 'stylesheet';
document.head.appendChild(link3);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ToastProvider>
      <App />
    </ToastProvider>
  </React.StrictMode>
);